import script from "./DropFile.vue?vue&type=script&setup=true&lang=js"
export * from "./DropFile.vue?vue&type=script&setup=true&lang=js"

import "./DropFile.vue?vue&type=style&index=0&id=9fcc0218&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fcc0218"]])

export default __exports__